import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SwUpdateService } from './core/services/sw-update.service';
import { AppCheck, getToken } from '@angular/fire/app-check';
import { FirebaseApp } from '@angular/fire/app';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, IonicModule, CommonModule],
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  private app = inject(FirebaseApp);
  private appCheck = inject(AppCheck, { optional: true }); // Optional - only if App Check is provided

  async ngOnInit() {
    // Service worker update service is initialized in constructor
    // This ensures updates are checked and handled automatically

    // Anonymous sign-in is now handled by APP_INITIALIZER (auth-init.service.ts)
    // This ensures the app doesn't load until anonymous auth is complete

    // App Check will initialize automatically - no need to force token generation on startup
    // Token generation happens automatically when needed (e.g., when calling functions)
  }
}







